module.exports = __webpack_public_path__ + "img/charging-hub-realized-semipublic.452c50f1.png";